import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { DeactivationGuardedComponent } from '@shared/models/component';

@Injectable()
export class ActivateComponentService {
  activatedComponent = new BehaviorSubject<DeactivationGuardedComponent>(null);
}
